export default {
    description: 'Usamos cookies para ajudar a personalizar conteúdo e oferecer uma experiência melhor e mais segura para você. Ao navegar no Astrolink, você concorda com o uso de cookies para coletar informações dentro e fora do site.',
    knowMore: 'Saiba mais!',
    understand: 'Entendi!',
    linkPrivacy: 'privacidade',
    preference: 'Preferência de cookies',
    policyTitle: 'Política de cookies',
    savePreference: 'Salvar preferência!',

    preferences: {
        privacy: {
            title: 'Uso de cookies no Astrolink',
            description: ` Ao acessar o Astrolink, assim como qualquer outro site, cookies podem ser utilizados para armazenar e recuperar informações no seu navegador. Tais informações geralmente não identificam você diretamente, mas fornecem dados sobre o dispositivo utilizado na navegação, suas preferências e escolhas, de forma que possamos disponibilizar uma experiência mais única e personalizada.
            O Astrolink respeita o seu direito à privacidade, por isso, disponibilizamos a informação de quais são os cookies utilizados no site, assim como seus respectivos propósitos e, no caso dos cookies que não são estritamente necessários à navegação, a opção de desabilitá-los.
            Através das configurações do seu navegador, você também pode optar por desabilitar o uso de todos os cookies, entretanto, o Astrolink, assim como muitos outros sites, não irão funcionar da maneira correta, ocasionando em diversos problemas durante o seu acesso.`
        },

        required: {
            title: 'Cookies estritamente necessários',
            description: `Os cookies estritamente necessários permitem a navegação e uso básico de nosso site. 
            Eles normalmente são definidos em respostas às suas ações dentro do site que equivalem a um pedido de serviços, como por exemplo escolha de preferências, preenchimento de formulários ou acesso à área logada. 
            Por serem essenciais ao funcionamento do site, não é possível desabilitá-los, pois isso acarretaria no impedimento do uso básico das funcionalidades do Astrolink. 
            Você ainda pode configurar seu navegador para bloquear todos os cookies, o que irá bloquear esses cookies mas também impedirá o acesso ao site.`,

            selector: {
                security: 'Segurança',
                title: 'Cookies Usados',
                lang: 'Definição de idioma',
                user: 'Experiência de usuário',
                access: 'Acesso à área logada',
            }
        },

        performance: {
            title: 'Cookies de desempenho',
            description: 'Os cookies de desempenho recolhem informações relacionadas à contagem do número de acessos às páginas (o que nos permite identificar páginas mais e menos populares), contagem de erros no site, fontes de tráfego e outras informações agregadas e anônimas que nos permitem entender e melhorar a forma como nosso site funciona.',
        },

        functional: {
            title: 'Cookies funcionais',
            description: `Os cookies funcionais nos permitem oferecer funções aprimoradas e funcionalidades personalizadas, reconhecendo quando um usuário volta ao nosso site. 
            Eles podem ser definidos pelo Astrolink ou por outros fornecedores cujos serviços nós utilizamos no nosso site. 
            Revogá-los pode fazer com que algumas partes do site não funcionem conforme esperado.`
        }
    }
};